import m from "mithril";
import { formatRupiah, formatDate } from "../../utils.js";
import PaginatedExpandableTable from "./PaginatedExpandableTable.js";

const RekapAngsuran = {
    view: function (vnode) {
        const { state } = vnode.attrs;

        return m(PaginatedExpandableTable, {
            state,
            columns: [
                { label: "No. Reg", cell: (item) => item.no_reg },
                { label: "Nama Nasabah", cell: (item) => item.nama_nasabah },
                { label: "Jml Pinjaman", align: "center", cell: (item) => item.loan_count },
                { label: "Jml Bayar", align: "center", cell: (item) => item.payment_count },
                { label: "Pokok", align: "right", cell: (item) => formatRupiah(item.total_principal) },
                { label: "Bunga", align: "right", cell: (item) => formatRupiah(item.total_interest) },
                { label: "B. Pelunasan", align: "right", cell: (item) => formatRupiah(item.settlement_interest || 0) },
                {
                    label: "Total Jasa", align: "right",
                    cellClass: "font-bold text-emerald-700 dark:text-emerald-400",
                    cell: (item) => formatRupiah(item.total_interest_incl_settlement ?? ((Number(item.total_interest) || 0) + (Number(item.settlement_interest) || 0)))
                },
                {
                    label: "Total Angsuran", align: "right",
                    cellClass: "font-bold text-gray-900 dark:text-white",
                    cell: (item) => formatRupiah(item.total_paid)
                }
            ],
            rowKey: (item) => item.customer_id,
            renderDetail: (detail) => {
                const payments = Array.isArray(detail) ? detail : (detail.payments || []);
                const settlements = Array.isArray(detail) ? [] : (detail.settlements || []);
                return m("div", [
                    m("p", { class: "text-xs font-bold text-gray-500 uppercase mb-2" }, "Angsuran"),
                    m("table", { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-md" }, [
                        m("thead", { class: "bg-gray-100 dark:bg-gray-800" }, [
                            m("tr", [
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Bayar"),
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Tgl Bayar"),
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Pencairan"),
                                m("th", { class: "px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase" }, "Angsuran ke"),
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Metode"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Pokok"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Bunga"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Total")
                            ])
                        ]),
                        m("tbody", { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" },
                            payments.length === 0 ?
                                m("tr", [
                                    m("td", { colspan: 8, class: "px-4 py-2 text-sm text-gray-500 text-center" }, "Tidak ada pembayaran angsuran")
                                ]) :
                                payments.map(row =>
                                    m("tr", [
                                        m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, row.payment_no || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, formatDate(row.payment_date)),
                                        m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, row.disbursement_no || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300 text-center" }, row.installment_number || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, row.payment_method || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatRupiah(row.principal_paid)),
                                        m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatRupiah(row.interest_paid)),
                                        m("td", { class: "px-4 py-2 text-sm text-right font-medium text-gray-900 dark:text-white" }, formatRupiah(row.total_paid))
                                    ])
                                )
                        )
                    ]),
                    m("p", { class: "text-xs font-bold text-gray-500 uppercase mt-4 mb-2" }, "Pelunasan"),
                    m("table", { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-md" }, [
                        m("thead", { class: "bg-gray-100 dark:bg-gray-800" }, [
                            m("tr", [
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Pelunasan"),
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Tgl Lunas"),
                                m("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "No. Pencairan"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Sisa Pokok"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Sisa Jasa"),
                                m("th", { class: "px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase" }, "Total Lunas")
                            ])
                        ]),
                        m("tbody", { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" },
                            settlements.length === 0 ?
                                m("tr", [
                                    m("td", { colspan: 6, class: "px-4 py-2 text-sm text-gray-500 text-center" }, "Tidak ada pelunasan")
                                ]) :
                                settlements.map(s =>
                                    m("tr", [
                                        m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, s.settlement_no || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-gray-700 dark:text-gray-300" }, formatDate(s.settlement_date)),
                                        m("td", { class: "px-4 py-2 text-sm font-mono text-gray-700 dark:text-gray-300" }, s.disbursement_no || "-"),
                                        m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatRupiah(s.remaining_principal)),
                                        m("td", { class: "px-4 py-2 text-sm text-right text-gray-700 dark:text-gray-300" }, formatRupiah(s.remaining_interest)),
                                        m("td", { class: "px-4 py-2 text-sm text-right font-medium text-gray-900 dark:text-white" }, formatRupiah(s.total_settlement_amount))
                                    ])
                                )
                        )
                    ])
                ]);
            },
            filterBar: (state) => {
                const filterApplied = !!(state.filters.startDate || state.filters.endDate || state.filters.search);
                return m("div", { class: "bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 mb-4 flex flex-col md:flex-row md:items-end gap-3" }, [
                    m("div", { class: "flex-1 min-w-[200px]" }, [
                        m("label", { class: "block text-xs text-gray-600 dark:text-gray-300 mb-1" }, "Nama Nasabah"),
                        m("input", {
                            type: "text",
                            placeholder: "Cari nama nasabah...",
                            class: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                            value: state.filters.search || "",
                            oninput: (e) => { state.filters.search = e.target.value; m.redraw(); },
                            onkeydown: (e) => { if (e.key === "Enter") state.refresh(); }
                        })
                    ]),
                    m("div", [
                        m("label", { class: "block text-xs text-gray-600 dark:text-gray-300 mb-1" }, "Dari Tanggal"),
                        m("input", {
                            type: "date",
                            class: "px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                            value: state.filters.startDate || "",
                            onchange: (e) => { state.filters.startDate = e.target.value; m.redraw(); }
                        })
                    ]),
                    m("div", [
                        m("label", { class: "block text-xs text-gray-600 dark:text-gray-300 mb-1" }, "Sampai Tanggal"),
                        m("input", {
                            type: "date",
                            class: "px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white",
                            value: state.filters.endDate || "",
                            onchange: (e) => { state.filters.endDate = e.target.value; m.redraw(); }
                        })
                    ]),
                    m("div", { class: "flex gap-2" }, [
                        m("button", {
                            class: "px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500",
                            onclick: () => state.refresh()
                        }, "Terapkan"),
                        filterApplied ? m("button", {
                            class: "px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none",
                            onclick: () => { state.filters.startDate = ""; state.filters.endDate = ""; state.filters.search = ""; state.refresh(); }
                        }, "Reset") : null,
                        m("button", {
                            class: "px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50",
                            onclick: () => state.exportExcel(),
                            disabled: state.exporting
                        }, state.exporting ? "Menyiapkan..." : "Export Excel")
                    ]),
                    m("div", { class: "ml-auto text-sm text-gray-500 dark:text-gray-400" },
                        filterApplied ? "Menampilkan data dalam rentang tanggal" : "Menampilkan semua data")
                ]);
            },
            totalsBar: (state) => {
                const totals = state.extra || { total_customers: 0, total_payments: 0, total_principal: 0, total_interest: 0, total_paid: 0 };
                const settlementInterest = Number(totals.total_settlement_interest) || 0;
                const settlementCount = Number(totals.total_settlements) || 0;
                const combinedInterest = (Number(totals.total_interest_incl_settlement) || ((Number(totals.total_interest) || 0) + settlementInterest));
                return m("div", [
                    m("div", { class: "px-6 py-4 bg-orange-50 dark:bg-gray-700/50 border-t border-gray-200 dark:border-gray-700 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3" }, [
                        m("div", [
                            m("p", { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" }, "Total Nasabah"),
                            m("p", { class: "text-lg font-bold text-gray-900 dark:text-white" }, totals.total_customers)
                        ]),
                        m("div", [
                            m("p", { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" }, "Total Pembayaran"),
                            m("p", { class: "text-lg font-bold text-gray-900 dark:text-white" }, totals.total_payments)
                        ]),
                        m("div", [
                            m("p", { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" }, "Total Pokok"),
                            m("p", { class: "text-lg font-bold text-gray-900 dark:text-white" }, formatRupiah(totals.total_principal))
                        ]),
                        m("div", [
                            m("p", { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" }, "Total Bunga"),
                            m("p", { class: "text-lg font-bold text-gray-900 dark:text-white" }, formatRupiah(totals.total_interest))
                        ]),
                        m("div", [
                            m("p", { class: "text-xs text-gray-500 dark:text-gray-400 uppercase" }, "Total Angsuran"),
                            m("p", { class: "text-lg font-bold text-orange-600 dark:text-orange-400" }, formatRupiah(totals.total_paid))
                        ])
                    ]),
                    m("div", { class: "px-6 py-3 bg-emerald-50 dark:bg-emerald-900/20 border-t border-gray-200 dark:border-gray-700" }, [
                        m("p", { class: "text-sm text-gray-700 dark:text-gray-200" }, [
                            m("span", "Rekonsiliasi jasa: "),
                            m("span", { class: "font-bold" }, `${formatRupiah(totals.total_interest)} (angsuran) + ${formatRupiah(settlementInterest)} (${settlementCount} pelunasan) = ${formatRupiah(combinedInterest)} (total jasa)`),
                        ]),
                        m("p", { class: "text-xs text-gray-500 dark:text-gray-400 mt-1" }, "Bandingkan dengan akuntansi (Pendapatan Jasa − Sisa Piutang Jasa) memakai tanggal cut-off yang sama. Rekap memuat data operasional tanpa filter posting.")
                    ])
                ]);
            },
            emptyText: "Tidak ada data angsuran"
        });
    }
};

export default RekapAngsuran;